/**
 * What a credential may do, as distinct from who it is.
 *
 * ADR-007 settled identity: a token says which person is acting, and role comes
 * from `company_users` at call time. ADR-009 adds this — the authority the
 * person delegated to that particular credential, which can be less than their
 * own and never more.
 *
 * The three scopes carved out of `mcp:write` follow one rule: carve it out if
 * it is permanent, or if it leaves the building. Permanent is not the same as
 * irreversible — an immutable entry, a closed period and a sent invoice each
 * have a designed correction path, and are safe inside `mcp:write`. The chart
 * of accounts has none: nothing deletes an account, and neither `code` nor
 * `type` can be changed after insertion.
 */
export const TOKEN_SCOPES = [
    /** Every read. */
    'mcp:read',
    /** Posting, drafting, reconciling, uploading, matching, settings. */
    'mcp:write',
    /** The account structure: the chart of accounts and the bank accounts bound to it. */
    'accounts:write',
    /** Closing a VAT period, which the database refuses to reopen. */
    'vat:close',
    /** Dispatch through Nemhandel, which reaches a real counterparty. */
    'einvoice:send',
];
/**
 * What a new grant starts with.
 *
 * Read and write, and neither carve-out: everything this permits has a way back.
 */
export const DEFAULT_TOKEN_SCOPES = ['mcp:read', 'mcp:write'];
export function isTokenScope(value) {
    return TOKEN_SCOPES.includes(value);
}
//# sourceMappingURL=scopes.js.map